import React from "react";
import { Typography, Box, Stack } from "@mui/material";
import { MzRadioGroup, MzRadio } from "@markaaz/ui/MzRadioControls";
import MzInput from "@markaaz/ui/MzInputControls";
import MzAlert from "@markaaz/ui/MzAlert";
const sx = {
  radio: {
    paddingLeft: "20px",
    "& .MuiButtonBase-root.MuiRadio-root": {
      color: (theme) => theme.palette.darkBlue.c50
    },
    "& .MuiButtonBase-root.MuiRadio-root.Mui-checked": {
      color: (theme) => theme.palette.blue.c100
    }
  }
};
function MySFTPRadio({ show, onInputFolder, inputFolder, folderError }) {
  return (
    <>
      {show === "sftpInputFolder" && (
        <Box sx={{ paddingLeft: "50px" }}>
          <Typography variant="body2" mt={4} mb={2}>
            Type the folder name where the file should be placed. Indicate sub folders with slash marks. If it’s the
            root folder, you can leave this blank.
          </Typography>
          <MzInput
            placeholder="ex: SFTP/Batch/September"
            value={inputFolder}
            label="Folder Name"
            fullWidth
            onChange={onInputFolder}
            error={!inputFolder || folderError}
            helperText={
              !inputFolder ? "Folder name cannot be empty." : folderError ? "Folder name cannot be same." : null
            }
          />
        </Box>
      )}
    </>
  );
}

function FileRetrievalConfiguration({
  onBatchRetrieval,
  permissions,
  batchRetrieval,
  inputFolder,
  folderError,
  showAlert,
  onInputFolder,
  onDisabledSection,
  onAlertClose
}) {
  return (
    <Box>
      <Box p={5}>
        <Typography variant="body1M" color="blue.c100">
          Batch File Retrieval
        </Typography>
        <Typography variant="body2" mt={1} mb={4}>
          Select where you would like the batch files to be retrieved from.
        </Typography>
        <Box sx={{ display: "flex" }}>
          <Stack onClick={!permissions.partnerHostedSFTP ? () => onDisabledSection("fileRetrievalSftp") : null}>
            <MzRadioGroup name="batchFileRetrieval" sx={sx.radio} onChange={onBatchRetrieval} value={batchRetrieval}>
              <MzRadio value="mySftpBatchRetrieval" label="Markaaz’s SFTP Input Folder" />
              <MzRadio value="sftpInputFolder" disabled={!permissions.partnerHostedSFTP} label="My SFTP" />
            </MzRadioGroup>
          </Stack>
          {showAlert.fileRetrievalSftp && (
            <MzAlert
              severity={"error"}
              sx={{ maxWidth: "352px", maxHeight: "40px", alignItems: "center", marginTop: "30px" }}
              onClose={() => {
                onAlertClose("fileRetrievalSftp");
              }}
            >
              Batch configuration not found
            </MzAlert>
          )}
        </Box>

        <MySFTPRadio
          show={batchRetrieval}
          folderError={folderError}
          inputFolder={inputFolder}
          onInputFolder={onInputFolder}
        />
      </Box>
    </Box>
  );
}

export default FileRetrievalConfiguration;
